const { createConstant } = require('../../helpers')

const service = 'customer-address'

module.exports = {
  GET_ADDRESS: createConstant(service, 'GET_ADDRESS'),
  GET_ADDRESS_SUCCESS: createConstant(service, 'GET_ADDRESS_SUCCESS'),
  GET_ADDRESS_ERROR: createConstant(service, 'GET_ADDRESS_ERROR'),
  GET_ADDRESS_RESET: createConstant(service, 'GET_ADDRESS_RESET'),

  CREATE_ADDRESS: createConstant(service, 'CREATE_ADDRESS'),
  CREATE_ADDRESS_SUCCESS: createConstant(service, 'CREATE_ADDRESS_SUCCESS'),
  CREATE_ADDRESS_ERROR: createConstant(service, 'CREATE_ADDRESS_ERROR'),
  CREATE_ADDRESS_RESET: createConstant(service, 'CREATE_ADDRESS_RESET'),

  UPDATE_ADDRESS: createConstant(service, 'UPDATE_ADDRESS'),
  UPDATE_ADDRESS_SUCCESS: createConstant(service, 'UPDATE_ADDRESS_SUCCESS'),
  UPDATE_ADDRESS_ERROR: createConstant(service, 'UPDATE_ADDRESS_ERROR'),
  UPDATE_ADDRESS_RESET: createConstant(service, 'UPDATE_ADDRESS_RESET'),
}
